module.exports = __webpack_public_path__ + "static/media/astral-nav-screenshot-1.e744df12.jpg";